import { Spin } from 'platform-components';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getCurrentYearCourseId } from 'common.components/course/selectors';

import { useCourseContainersQuery } from '../library.course-container/queries';

import { ContainerBanner } from './__container-banner/course-container-list__container-banner';
import { EmptyState } from './__empty-state/course-container-list__empty-state';
import { CourseContainerHelpBanner } from './__help-banner/course-container-list__help-banner';

import './course-container-list.scss';

export const CourseContainerList = memo(function CourseContainerList() {
    const { classId } = useParams<{ classId: string }>();
    const courseId = useSelector(getCurrentYearCourseId);
    const query = useCourseContainersQuery(courseId);

    if (query.isLoading) {
        return <Spin center />;
    }

    return (
        <div className="course-container-list">
            {query.data?.length ? (
                query.data.map((courseContainer) => (
                    <ContainerBanner courseContainer={courseContainer} key={courseContainer.container.slug} />
                ))
            ) : (
                <EmptyState classId={classId} />
            )}

            <CourseContainerHelpBanner />
        </div>
    );
});
